import React from 'react';
import { ReturnLink, SelectPartMessage } from '../VisualComponents';

const PartNotFoundMessage = ({ searchedPartNumber }) => (
  <SelectPartMessage>
    <p>
      {`Part number "${searchedPartNumber}" not found. Please confirm the part number and try again. Not seeing your p/n? Check`}{' '}
      <ReturnLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.calix.com/my-calix/eol-notices.html"
      >
        here
      </ReturnLink>{' '}
      for EOL OR check{' '}
      <ReturnLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.calix.com/bin/calix/servlets/docdownload?fileId=/content/dam/calix/doc-library/oem/oem-product-information/cabs/oem-product-planning-related-notices/cab-18-032/cab-18-032_Cabinet_Product_Line_Announcement.pdf"
      >
        here
      </ReturnLink>{' '}
      for Clearfield.
    </p>
  </SelectPartMessage>
);

export default PartNotFoundMessage;
